import { useCallback } from "react";
import { copyTextToClipboard } from "@lib/clipboardUtils";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useTypedFlags } from "./useTypedFlags";

interface UseIdCopyOptions {
    label?: string;
}

export const useIdCopy = (options: UseIdCopyOptions = {}) => {
    const { showDbIds } = useTypedFlags();
    const { toast } = useToaster();
    const { label = "ID" } = options;

    const copyId = useCallback(
        async (e: React.MouseEvent, id: string | number) => {
            e.preventDefault();
            e.stopPropagation();

            if (id) {
                const copied = await copyTextToClipboard(String(id));
                if (copied) {
                    toast(`${label} ID copied: ${id}`);
                }
            }
        },
        [toast, label],
    );

    const getCopyProps = useCallback(
        (id?: string | number) => ({
            onContextMenu:
                showDbIds && id
                    ? (e: React.MouseEvent) => copyId(e, id)
                    : undefined,
            title:
                showDbIds && id ? `Right-click to copy ${label} ID` : undefined,
        }),
        [showDbIds, copyId, label],
    );

    return {
        getCopyProps,
    };
};
